import type { ServiceType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import ServiceTableRow from './ServiceTableRow';

interface ServiceTableBodyProps {
    servicesList: ServiceType[];
    fetchServices: (force?: boolean) => Promise<unknown>;
}

const ServiceTableBody = ({ servicesList, fetchServices }: ServiceTableBodyProps) => {
    return (
        <tbody>
            {servicesList?.map((service) => (
                <ServiceTableRow key={service.ID} service={service} fetchServices={fetchServices} />
            ))}

            {servicesList.length === 0 && (
                <tr>
                    <td colSpan={6}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ServiceTableBody;
